import { render, staticRenderFns } from "./SidebarMobile.vue?vue&type=template&id=867990da&"
var script = {}
import style0 from "./SidebarMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports